<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true
            }
          ],
          yAxes: [
            {
              stacked: true
            }
          ]
        }
      }
    }
  },
  mounted() {
    this.prepareChartData()
  },
  watch: {
    data() {
      this.prepareChartData()
    }
  },
  methods: {
    prepareChartData() {
      const labels = this.data.map(item => item.subjectGroup)
      const datasets = [
        {
          label: '0 đến 1', // Bad
          backgroundColor: '#F43A00', // Red for bad performance
          data: this.data.map(item => item['0To1'])
        },
        {
          label: '1 đến 2',
          backgroundColor: '#FB8B01',
          data: this.data.map(item => item['1To2'])
        },
        {
          label: '2 đến 3',
          backgroundColor: '#FFAB0B',
          data: this.data.map(item => item['2To3'])
        },
        {
          label: '3 đến 4',
          backgroundColor: '#FDD42E',
          data: this.data.map(item => item['3To4'])
        },
        {
          label: '4 đến 5',
          backgroundColor: '#FFEB00',
          data: this.data.map(item => item['4To5'])
        },
        {
          label: '5 đến 6',
          backgroundColor: '#619DFF',
          data: this.data.map(item => item['5To6'])
        },
        {
          label: '6 đến 7',
          backgroundColor: '#6EB9FF',
          data: this.data.map(item => item['6To7'])
        },
        {
          label: '7 đến 8',
          backgroundColor: '#6CE5FF',
          data: this.data.map(item => item['7To8'])
        },
        {
          label: '8 đến 9',
          backgroundColor: '#68F9BC',
          data: this.data.map(item => item['8To9'])
        },
        {
          label: '9 đến 10',
          backgroundColor: '#43F340',
          data: this.data.map(item => item['9To10'])
        }
      ]

      this.chartData = {
        labels,
        datasets
      }
      this.renderChart(this.chartData, this.chartOptions)
    }
  }
}
</script>
